import styled from "styled-components";

export const ImageSliderTemplatesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  & > div {
    &:not(:first-child) {
      padding-top: 20px;
      border-top: 1px solid rgba(0, 0, 0, 0.15);
    }

    & > div {
      height: 200px;
      cursor: pointer;
    }
  }
`;

export const OverviewImageSlidersTemplatesContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 1px minmax(0, 1fr);
  gap: 64px;

  & > div > div {
    height: 200px;
    cursor: pointer;
  }
`;

export const Divider = styled.div`
  opacity: 0.5;
  background: rgba(0, 0, 0, 0.15);
  width: 1px;
  height: 100%;
`;
